<template>
  <ValidationProvider :name="$attrs.label" :rules="rules" v-slot="{ errors, valid }">
    <v-switch
        v-model="innerValue"
        v-bind="$attrs"
        v-on="$listeners"
        :error-messages="errors.concat($attrs.errors || [])"
        :label="$t(`label.${$attrs.label}`) + ($attrs['append-label'] ? `: ${$tc('label.' + $attrs['append-label'], innerValue)}` : '')"
        :class="{'active-switch': innerValue, 'inactive-switch': !innerValue}"
    />
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String, Number, null],
      default: ""
    },
    // must be included in props
    value: {
      type: null
    }
  },
  data: () => ({
    innerValue: false
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
<style>
.gender-switch .inactive-switch .v-input--selection-controls__input div {
  color: #F48FB1 !important;
}
.gender-switch .active-switch .v-input--selection-controls__input div {
  color: #64B5F6 !important;
}
</style>